import { useState } from 'react';
import Loader from "react-loader-spinner";

function NotificationHeaderArea(props) {
  const [isRead, setIsRead] = useState(false);

    return (
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="d-flex">
          <div
            className="d-flex align-items-center"
            style={{
              whiteSpace: "nowrap",
            }}
          >
              <div className="px-2">
              <button
              onClick={() => {
                props.handleSelectAll();
              }}
              type="button"
              className="d-flex align-items-center btn btn-primary font-weight-bold"
            >
              {props.t("notifications.selectAll")}
            </button>  
            </div>
              <div className="px-2">
            <button
              onClick={() => {
                props.handleMarkAsRead();
              }}
              type="button"
              className="d-flex align-items-center btn btn-primary font-weight-bold"
            >
              {props.t("notifications.markAsRead")}
            </button>
          </div>
          <div>
          <button
              onClick={() => {
                props.handleSnoozeModal();
              }}
              type="button"
              className="d-flex align-items-center btn btn-primary font-weight-bold"
            >
              {props.t("notifications.snoozeOn")}
            </button>
          </div>
          <div className="px-2">
          <button disabled={props.buttonLoading}
              onClick={() => {
                props.setButtonLoading(true);
                props.handleSnoozeOff();
              }}
              type="button"
              className="d-flex align-items-center btn btn-primary font-weight-bold"
            >
              {props.t("notifications.snoozeOff")} {props.buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
            </button>
          </div>
            <div className="float-end  form-switch form-switch-secondary">
              <input className="form-check-input background-color-red" style={{backgroundColor: (isRead ? 'green' : '')}} type="checkbox" checked={isRead} onChange={() => {setIsRead(!isRead); props.handleArchived(!isRead);}} />
              <label className="form-check-label text-black ps-2 pe-3">{props.t("notifications.showRead")}</label>
            </div>
          </div>
        </div>
      </div>
    );
  }
  export default NotificationHeaderArea;